// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../../pplx/frontend/api-clients/core/client.js';
export const autosuggestHealthClient = createTypedClient();
export const createAutosuggestHealthClient = (config) => createTypedClient(config);
